import type { ReduxState } from '../types/internal/ReduxState';

export default ({ language }: ReduxState): string => language;
